'use client';

import Link from 'next/link';
import type { SearchResult } from '@/lib/types';
import { THEME_COLORS } from '@/lib/constants';

interface SearchResultsProps {
  results: SearchResult[];
}

export default function SearchResults({ results }: SearchResultsProps) {
  if (results.length === 0) return null;

  return (
    <div className="space-y-3">
      {results.map((result, i) => (
        <Link
          key={i}
          href={`/reader/${encodeURIComponent(result.book)}/${result.chapter}`}
          className="block p-4 rounded-xl transition-all duration-200"
          style={{
            backgroundColor: 'var(--bg-card)',
            border: '1px solid rgba(200, 164, 94, 0.1)',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.borderColor = 'rgba(200, 164, 94, 0.25)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.borderColor = 'rgba(200, 164, 94, 0.1)';
          }}
        >
          <div className="flex items-start justify-between gap-4 mb-2">
            <span
              className="text-sm font-semibold"
              style={{ color: 'var(--accent-gold)' }}
            >
              {result.book} {result.chapter}:{result.verse}
            </span>

            {/* Relevance score bar */}
            <div className="flex items-center gap-2 shrink-0">
              <div
                className="w-16 h-1.5 rounded-full overflow-hidden"
                style={{ backgroundColor: 'rgba(200, 164, 94, 0.1)' }}
              >
                <div
                  className="h-full rounded-full transition-all"
                  style={{
                    width: `${Math.round(result.score * 100)}%`,
                    backgroundColor: 'var(--accent-gold)',
                  }}
                />
              </div>
              <span
                className="text-xs"
                style={{ color: 'var(--text-secondary)' }}
              >
                {Math.round(result.score * 100)}%
              </span>
            </div>
          </div>

          <p
            className="text-sm leading-relaxed mb-2"
            style={{ color: 'var(--text-primary)' }}
          >
            {result.text}
          </p>

          {/* Theme pills */}
          {result.translation && (
            <span
              className="text-xs px-1.5 py-0.5 rounded"
              style={{
                backgroundColor: 'rgba(74, 125, 189, 0.15)',
                color: 'var(--accent-blue)',
              }}
            >
              {result.translation.toUpperCase()}
            </span>
          )}
        </Link>
      ))}
    </div>
  );
}
